
interface Specification {
  label: string;
  value: string;
}

interface ProductSpecificationsProps {
  specifications: Specification[];
}

export default function ProductSpecifications({ specifications }: ProductSpecificationsProps) {
  return (
    <section className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Technical Specifications</h2>
          <p className="text-lg text-gray-600">
            Detailed technical specifications for our control valves and accessories
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-gray-50 rounded-2xl overflow-hidden">
            <div className="bg-red-600 text-white p-6">
              <h3 className="text-xl font-semibold">Control Valve Specifications</h3>
            </div>
            
            <div className="p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
                {specifications.map((spec, index) => (
                  <div key={index} className="flex justify-between items-center py-3 border-b border-gray-200 last:border-b-0">
                    <span className="font-medium text-gray-700">{spec.label}:</span>
                    <span className="text-gray-900 font-semibold">{spec.value}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Size Chart */}
          <div className="mt-12 bg-gray-50 rounded-2xl p-8">
            <h3 className="text-xl font-semibold text-gray-900 mb-6 text-center">Available Sizes</h3>
            <div className="grid grid-cols-2 md:grid-cols-6 gap-4">
              {['2"', '3"', '4"', '6"', '8"', '12"'].map((size, index) => (
                <div key={index} className="text-center">
                  <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-2 shadow-sm">
                    <span className="font-bold text-red-600">{size}</span>
                  </div>
                  <div className="text-sm text-gray-600">DN{(index + 1) * 50}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Material Options */}
          <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
              <h4 className="font-semibold text-blue-900 mb-3 flex items-center">
                <i className="ri-hammer-line mr-2"></i>
                Ductile Iron Valves
              </h4>
              <ul className="text-blue-800 text-sm space-y-1">
                <li>• High strength and durability</li>
                <li>• Corrosion-resistant coating</li>
                <li>• Suitable for underground installation</li>
                <li>• Cost-effective solution</li>
              </ul>
            </div>
            
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-6">
              <h4 className="font-semibold text-amber-900 mb-3 flex items-center">
                <i className="ri-copper-coin-line mr-2"></i>
                Brass Valves
              </h4>
              <ul className="text-amber-800 text-sm space-y-1">
                <li>• Excellent corrosion resistance</li>
                <li>• Smooth operation</li>
                <li>• Ideal for smaller sizes</li>
                <li>• Premium quality finish</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
